/**
 * Iniciales para avatar (máx. 2 caracteres).
 * Nombre: "Juan Pérez" → "JP". Email: local de la parte antes de @.
 */
export function getUserInitials(source) {
  const s = String(source ?? "").trim();
  if (!s) return "?";
  if (s.includes("@")) {
    const local = s.split("@")[0].replace(/[^a-zA-ZÀ-ÿ0-9]/gi, "");
    if (!local) return "?";
    return local.slice(0, 2).toUpperCase();
  }
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    const a = parts[0][0] || "";
    const b = parts[parts.length - 1][0] || "";
    const out = `${a}${b}`.toUpperCase();
    return out || "?";
  }
  const one = parts[0] || s;
  return one.slice(0, 2).toUpperCase();
}
